module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("Copyright © 2023 S.C. Butler, Joshua Palmatier, and")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("Zombies Need Brains LLC")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("All Rights Reserved")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("Interior Design (ebook):  ZNB Design")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("Interior Design (print):  ZNB Design")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("Cover Design by ZNB Design")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("Cover Art “Dragonesque”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("by Justin Adams of Varia Studios")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("ZNB Book Collectors #27")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("All characters and events in this book are fictitious.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("All resemblance to persons living or dead is coincidental.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("The scanning, uploading, and distribution of this book via the Internet or any other means without the permission of the publisher is illegal and punishable by law.  Please purchase only authorized electronic editions of this book, and do not participate or encourage electronic piracy of copyrighted material.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("Kickstarter Edition Printing, June 2023")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("First Printing, July 2023")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("Print ISBN-13:  978-1940709529")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("Ebook ISBN-13:  978-1940709536")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Copyright"
  }, [_c('span', [_vm._v("Printed in the U.S.A.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3525a27c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0004.vue
// module id = 69
// module chunks = 0